import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [disableTransition, setDisableTransition] = useState(false);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  // Slider data with different content for each slide
  const sliderData = [
    {
      badge: { icon: "Award", text: "Über 15 Jahre Erfahrung" },
      headline: {
        main: "Professionelle",
        accent: "Autopflege",
        sub: "für Ihren Traumwagen"
      },
      description: "NANO-Versiegelung, Lackreparatur und Premium-Detailing in Dinslaken. Ihr Auto verdient das Beste – wir liefern Perfektion.",
      image: "/assets/images/Generated Image October 04, 2025 - 12_26AM.png",
      imageAlt: "Professionelle Autopflege - Clean Paradise"
    },
    {
      badge: { icon: "Shield", text: "Premium Qualität" },
      headline: {
        main: "Lackaufbereitung",
        accent: "Perfektion",
        sub: "für makellosen Glanz"
      },
      description: "Professionelle Lackaufbereitung und Polierung für perfekte Ergebnisse. Wir entfernen Kratzer, Hologramme und Oxidation für einen atemberaubenden Glanz.",
      image: "/assets/images/vecteezy_car-being-polished_2117775.jpg",
      imageAlt: "Lackaufbereitung und Polierung"
    },
    {
      badge: { icon: "Award", text: "Premium Schutz" },
      headline: {
        main: "Tango",
        accent: "Wachs",
        sub: "ultimativer Glanz"
      },
      description: "Premium Tango Wachs für langanhaltenden Schutz und brillanten Glanz. Unsere spezielle Wachstechnologie versiegelt den Lack und schützt vor Witterungseinflüssen für Monate.",
      image: "/assets/images/Generated Image October 04, 2025 - 12_39AM.png",
      imageAlt: "Tango Wachs - Premium Wachsschutz"
    },
    {
      badge: { icon: "Sparkles", text: "Sanfte Handarbeit" },
      headline: {
        main: "Außenhandwäsche",
        accent: "Premium",
        sub: "für Ihren Lack"
      },
      description: "Schonende Handwäsche mit hochwertigen Produkten für maximale Lackpflege. Wir entfernen Schmutz und Ablagerungen ohne Kratzer zu verursachen.",
      image: "/assets/images/vecteezy_a-person-washing-the-front-of-a-red-car_58142368.jpg",
      imageAlt: "Außenhandwäsche - Professionelle Autopflege"
    },
    {
      badge: { icon: "Shield", text: "Detailarbeit" },
      headline: {
        main: "Innenreinigung",
        accent: "Präzision",
        sub: "in jedem Detail"
      },
      description: "Gründliche Innenreinigung mit speziellen Werkzeugen und Produkten. Wir erreichen jede Ritze und jedes Fach für eine vollständige Sauberkeit im Innenraum.",
      image: "/assets/images/vecteezy_close-up-hand-interior-car-cleaning_35034131.jpg",
      imageAlt: "Detailierte Innenreinigung - Clean Paradise"
    },
    {
      badge: { icon: "Star", text: "Premium Pflege" },
      headline: {
        main: "Lederpflege",
        accent: "Schutz",
        sub: "für edle Oberflächen"
      },
      description: "Spezielle Lederpflege für Sitze, Lenkräder und Armaturen. Wir verwenden hochwertige Pflegeprodukte für langanhaltenden Schutz und Geschmeidigkeit.",
      image: "/assets/images/vecteezy_taking-care-about-brown-colored-seats-modern-black_16727981.jpg",
      imageAlt: "Lederpflege - Premium Lederschutz"
    },
    {
      badge: { icon: "Shield", text: "High-Tech Schutz" },
      headline: {
        main: "Nanoversiegelung",
        accent: "Premium",
        sub: "Langzeitschutz"
      },
      description: "Professionelle Nanoversiegelung für ultimativen Schutz Ihres Fahrzeugs. Unsichtbare Schutzschicht gegen Kratzer, Schmutz und Witterungseinflüsse für bis zu 3 Jahre.",
      image: "/assets/images/vecteezy_wet-car-under-dark-sky_10218168.jpg",
      imageAlt: "Nanoversiegelung - High-Tech Fahrzeugschutz"
    },
    {
      badge: { icon: "Award", text: "Premium Schutz" },
      headline: {
        main: "Keramikversiegelung",
        accent: "Maximum",
        sub: "Haltbarkeit"
      },
      description: "Hochwertige Keramikversiegelung für extremen Schutz Ihres Fahrzeugs. Keramische Schutzschicht mit Härtegrad 9H für bis zu 5 Jahre Schutz gegen Kratzer und Umwelteinflüsse.",
      image: "/assets/images/vecteezy_a-man-in-an-orange-overall-is-working-on-a-car_71101018.jpeg",
      imageAlt: "Keramikversiegelung - Premium Fahrzeugschutz"
    },
    {
      badge: { icon: "Sparkles", text: "Tiefenreinigung" },
      headline: {
        main: "Polsterreinigung",
        accent: "Professionell",
        sub: "für frische Innenräume"
      },
      description: "Professionelle Polsterreinigung für Sitze, Teppiche und Verkleidungen. Wir entfernen Flecken, Gerüche und Schmutz für hygienische Sauberkeit in Ihrem Fahrzeug.",
      image: "/assets/images/vecteezy_a-man-cleaning-the-interior-of-a-car_71102777.jpeg",
      imageAlt: "Polsterreinigung - Professionelle Innenraumreinigung"
    },
    {
      badge: { icon: "Star", text: "Detailarbeit" },
      headline: {
        main: "Himmelreinigung",
        accent: "Spezial",
        sub: "für den Dachhimmel"
      },
      description: "Spezielle Reinigung des Dachhimmels und der Innenverkleidung. Wir entfernen sanft Staub, Flecken und Verunreinigungen für ein frisches Fahrzeuginnenraum-Gefühl.",
      image: "/assets/images/Gemini_Generated_Image_rolha5rolha5rolh.png",
      imageAlt: "Himmelreinigung - Spezialreinigung Dachhimmel"
    },
    {
      badge: { icon: "Shield", text: "Technische Pflege" },
      headline: {
        main: "Motor",
        accent: "Wäsche",
        sub: "professionelle Reinigung"
      },
      description: "Professionelle Motorwäsche mit speziellen Reinigern und schonender Technik. Wir säubern den Motorraum gründlich und schützen sensible Bauteile vor Korrosion.",
      image: "/assets/images/Gemini_Generated_Image_mqvszjmqvszjmqvs.png",
      imageAlt: "Motor Wäsche - Professionelle Motorraumreinigung"
    },
    {
      badge: { icon: "Award", text: "Komplettservice" },
      headline: {
        main: "Innen",
        accent: "Komplett",
        sub: "rundum sauber"
      },
      description: "Komplettes Innenraum-Programm für Ihr Fahrzeug. Von der Tiefenreinigung aller Oberflächen bis zur Politur der Kunststoffteile - für ein neuwertiges Innenraum-Erlebnis.",
      image: "/assets/images/vecteezy_a-person-in-black-gloves-cleaning-the-dashboard-of-a-car_71102465.jpeg",
      imageAlt: "Innen Komplett - Vollständige Innenraumreinigung"
    },
    {
      badge: { icon: "Sparkles", text: "Premium Finish" },
      headline: {
        main: "Polieren",
        accent: "Professionell",
        sub: "für perfekten Glanz"
      },
      description: "Professionelles Polieren für Lack, Kunststoff und Metallteile. Wir entfernen feine Kratzer und bringen alle Oberflächen zum Strahlen für einen showroom-würdigen Glanz.",
      image: "/assets/images/vecteezy_car-detailing-male-mechanic-holding-car-polishing-machine_3582888.jpg",
      imageAlt: "Polieren - Professionelle Oberflächenbehandlung"
    },
  ];

  // Auto-cycling functionality
  useEffect(() => {
    if (isPaused) return; // Don't auto-cycle when paused
    
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % sliderData.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, [isPaused]);

  // Handle manual slide change
  const handleSlideChange = (index) => {
    const currentIndex = currentSlide;
    const slideDifference = Math.abs(index - currentIndex);

    // If jumping more than 1 slide, temporarily disable transition for smooth jump
    if (slideDifference > 1) {
      setDisableTransition(true);
      setCurrentSlide(index);

      // Re-enable transition after a brief moment
      setTimeout(() => {
        setDisableTransition(false);
      }, 50);
    } else {
      setCurrentSlide(index);
    }

    setIsPaused(true);

    // Resume auto-cycling after 10 seconds of inactivity
    setTimeout(() => {
      setIsPaused(false);
    }, 10000);
  };

  // Touch handlers for mobile swipe
  const handleTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe && currentSlide < sliderData.length - 1) {
      handleSlideChange(currentSlide + 1);
    }
    if (isRightSwipe && currentSlide > 0) {
      handleSlideChange(currentSlide - 1);
    }
  };

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const headerHeight = 80;
      const elementPosition = element?.getBoundingClientRect()?.top + window.pageYOffset;
      const offsetPosition = elementPosition - headerHeight;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const currentData = sliderData[currentSlide];

  return (
    <section className="relative h-[800px] md:h-[700px] flex flex-col md:flex-row items-start overflow-hidden -mt-20 pt-0 bg-gradient-to-r from-gray-600 via-gray-300 to-white z-100">
      {/* Mobile: Full width content, Desktop: Left Side - Text Content */}
      <div className="w-full md:w-1/2 bg-transparent flex items-start justify-center relative h-full md:h-full z-20">
        <div className="max-w-xl px-4 md:px-12 py-8 transition-all duration-700 ease-in-out">
          {/* Badge */}
          <div className="inline-flex items-center space-x-1 bg-primary/10 rounded-full px-3 py-1 mb-4">
            <Icon name={currentData.badge.icon} size={12} color="black" />
            <span className="text-black text-xs font-medium">{currentData.badge.text}</span>
          </div>

          {/* Main Headline - Responsive height container */}
          <div className="h-24 md:h-32 mb-4">
            <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
              {currentData.headline.main}
              <span className="block text-primary font-accent">{currentData.headline.accent}</span>
              {currentData.headline.sub}
            </h1>
          </div>

          {/* Subheadline - Responsive height container */}
          <div className="h-16 md:h-20 mb-12">
            <p className="text-sm md:text-base text-black leading-relaxed">
              {currentData.description}
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-start space-y-3 sm:space-y-0 sm:space-x-4 mb-8">
            <button
              className="inline-flex items-center justify-center text-sm rounded-full bg-primary px-6 py-2 font-semibold text-white transition-all duration-200 hover:bg-primary/90 hover:shadow-xl hover:-translate-y-0.5 shadow-lg"
              style={{boxShadow: '0 0 20px rgba(235, 204, 137, 0.4), 0 0 40px rgba(235, 204, 137, 0.2)'}}
              onClick={scrollToContact}
            >
              Termin vereinbaren
              <svg
                aria-hidden="true"
                viewBox="0 0 10 10"
                height="8"
                width="8"
                fill="none"
                className="mt-0.5 ml-1 -mr-1 stroke-white stroke-1.5"
              >
                <path
                  d="M0 5h7"
                  className="transition opacity-0 group-hover:opacity-100"
                ></path>
                <path
                  d="M1 1l4 4-4 4"
                  className="transition group-hover:translate-x-[3px]"
                ></path>
              </svg>
            </button>
            
            <button
              className="inline-flex items-center justify-center text-sm rounded-full bg-white border-2 border-primary px-6 py-2 font-semibold text-primary transition-all duration-200 hover:bg-primary/5 hover:shadow-xl hover:-translate-y-0.5 shadow-lg"
              style={{boxShadow: '0 0 20px rgba(235, 204, 137, 0.3), 0 0 40px rgba(235, 204, 137, 0.15)'}}
              onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Services entdecken
              <svg
                aria-hidden="true"
                viewBox="0 0 10 10"
                height="8"
                width="8"
                fill="none"
                className="mt-0.5 ml-1 -mr-1 stroke-primary stroke-1.5"
              >
                <path
                  d="M0 5h7"
                  className="transition opacity-0 group-hover:opacity-100"
                ></path>
                <path
                  d="M1 1l4 4-4 4"
                  className="transition group-hover:translate-x-[3px]"
                ></path>
              </svg>
            </button>
          </div>

          {/* Trust Indicators - Responsive grid */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-4">
            <div className="flex flex-col items-start space-y-1">
              <div className="w-6 h-6 md:w-8 md:h-8 bg-primary/10 rounded-full flex items-center justify-center">
                <Icon name="MapPin" size={12} color="black" />
              </div>
              <span className="text-gray-700 text-xs font-medium">1 Standort</span>
            </div>
            <div className="flex flex-col items-start space-y-1">
              <div className="w-6 h-6 md:w-8 md:h-8 bg-primary/10 rounded-full flex items-center justify-center">
                <Icon name="Users" size={12} color="black" />
              </div>
              <span className="text-gray-700 text-xs font-medium">5000+ Kunden</span>
            </div>
            <div className="flex flex-col items-start space-y-1">
              <div className="w-6 h-6 md:w-8 md:h-8 bg-primary/10 rounded-full flex items-center justify-center">
                <Icon name="Star" size={12} color="black" />
              </div>
              <span className="text-gray-700 text-xs font-medium">4.9/5 Bewertung</span>
            </div>
            <div className="flex flex-col items-start space-y-1">
              <div className="w-6 h-6 md:w-8 md:h-8 bg-primary/10 rounded-full flex items-center justify-center">
                <Icon name="Shield" size={12} color="black" />
              </div>
              <span className="text-gray-700 text-xs font-medium">Garantie</span>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile: Show images below content, Desktop: Right Side - Image with Blur Effect */}
      <div 
        className="w-full md:w-1/2 relative z-10 h-2/3 md:h-full overflow-hidden"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <div
          className={`flex h-full ${disableTransition ? '' : 'transition-transform duration-700 ease-in-out'}`}
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >
          {sliderData.map((data, index) => (
            <div key={index} className="w-full h-full flex-shrink-0 relative overflow-hidden">
              <Image
                src={data.image}
                alt={data.imageAlt}
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </div>
        {/* Gradient overlay that shows over the image */}
        <div className="absolute left-0 top-0 w-full h-full bg-gradient-to-r from-gray-300 via-gray-2000 via-transparent to-transparent z-20 pointer-events-none"></div>
        
        {/* Slide Indicators - At the bottom middle - Hidden on mobile */}
        <div className="hidden md:flex absolute bottom-2 md:bottom-4 left-1/2 transform -translate-x-1/2 space-x-2 md:space-x-3 z-30">
          {sliderData.map((_, index) => (
            <button
              key={index}
              onClick={() => handleSlideChange(index)}
              className={`w-4 h-4 rounded-full transition-all duration-300 ${
                index === currentSlide 
                  ? 'bg-primary scale-110' 
                  : 'bg-white/70 hover:bg-white'
              }`}
            />
          ))}
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-2 md:bottom-4 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-4 h-6 border-2 border-gray-400 rounded-full flex justify-center">
          <div className="w-0.5 h-2 bg-gray-400 rounded-full mt-1 animate-pulse" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;